import React, { useEffect, useState } from 'react';
import { getInvite, register, setToken, User } from '../api';

interface Props {
  code: string;
  onRegister: (user: User) => void;
}

export default function Invite({ code, onRegister }: Props) {
  const [slackId, setSlackId] = useState('');
  const [slackName, setSlackName] = useState('');
  const [loginId, setLoginId] = useState('');
  const [name, setName] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPw, setConfirmPw] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [invalid, setInvalid] = useState(false);

  useEffect(() => {
    getInvite(code)
      .then((data) => {
        setSlackId(data.slack_user_id);
        setSlackName(data.slack_user_name || '');
      })
      .catch(() => setInvalid(true));
  }, [code]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (password !== confirmPw) {
      setError('비밀번호가 일치하지 않습니다.');
      return;
    }
    setError('');
    setLoading(true);
    try {
      const data = await register(code, loginId, name, password);
      setToken(data.token);
      onRegister(data.user);
    } catch (err: any) {
      setError(err.message || '가입 실패. 이미 등록된 계정이거나 초대가 만료되었습니다.');
    }
    setLoading(false);
  };

  if (invalid) {
    return (
      <div className="auth-page">
        <div className="auth-card">
          <h1>초대 링크 오류</h1>
          <p className="auth-desc">유효하지 않거나 만료된 초대 링크입니다.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h1>Agent LINKO 가입</h1>
        <p className="auth-desc">초대를 통해 가입합니다</p>
        <form onSubmit={handleSubmit}>
          <div className="auth-info">
            <span className="auth-label">Slack ID</span>
            <span>{slackId}</span>
          </div>
          {slackName && (
            <div className="auth-info">
              <span className="auth-label">Slack</span>
              <span>{slackName}</span>
            </div>
          )}
          <input
            type="text"
            placeholder="아이디 (3~20자, 영문/숫자/밑줄)"
            value={loginId}
            onChange={(e) => setLoginId(e.target.value)}
          />
          <input
            type="text"
            placeholder="이름"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <input
            type="password"
            placeholder="비밀번호 (영문+숫자+특수문자, 8자 이상)"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <input
            type="password"
            placeholder="비밀번호 확인"
            value={confirmPw}
            onChange={(e) => setConfirmPw(e.target.value)}
          />
          {error && <div className="auth-error">{error}</div>}
          <button type="submit" disabled={loading || !loginId || !name || !password || !confirmPw}>
            {loading ? '가입 중...' : '가입하기'}
          </button>
        </form>
      </div>
    </div>
  );
}
